import { render } from "./FootPage.vue?vue&type=template&id=c5e32386"
import script from "./FootPage.vue?vue&type=script&lang=js"
export * from "./FootPage.vue?vue&type=script&lang=js"

import "./FootPage.vue?vue&type=style&index=0&id=c5e32386&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__